import { DocumentCategoryDto } from '@cradua/data';
import { createAction, props } from '@ngrx/store';

/**
 * Load Countries Collection Actions
 */
export const loadDocumentCategory = createAction(
  '[DocumentCategory] Load DocumentCategory'
);

export const loadDocumentCategorySuccess = createAction(
  '[DocumentCategory] Load DocumentCategory Success',
  props<{ documentCategory: DocumentCategoryDto[] }>()
);

export const loadDocumentCategoryFailure = createAction(
  '[DocumentCategory] Load DocumentCategory Failure',
  props<{ error: any }>()
);

/**
 * Add Countries to Collection Actions
 */
export const addDocumentCategory = createAction(
  '[DocumentCategory] Add DocumentCategory',
  props<{ newDocumentCategory: DocumentCategoryDto[] }>()
);

export const addDocumentCategorySuccess = createAction(
  '[DocumentCategory] Add DocumentCategory Success',
  props<{ newDocumentCategory: DocumentCategoryDto[] }>()
);

export const addDocumentCategoryFailure = createAction(
  '[DocumentCategory] Add DocumentCategory Failure',
  props<{ error: any }>()
);

/**
 * Update DocumentCategory Collection Actions
 */
export const updateDocumentCategory = createAction(
  '[DocumentCategory] Update DocumentCategory',
  props<{ updateDocumentCategory: DocumentCategoryDto[] }>()
);

export const updateDocumentCategorySuccess = createAction(
  '[DocumentCategory] Update DocumentCategory Success',
  props<{ updateDocumentCategory: DocumentCategoryDto[] }>()
);

export const updateDocumentCategoryFailure = createAction(
  '[DocumentCategory] Update DocumentCategory Failure',
  props<{ error: any }>()
);

/**
 * Remove DocumentCategory Collection Actions
 */
export const removeDocumentCategory = createAction(
  '[DocumentCategory] Remove DocumentCategory',
  props<{ ids: string[] }>()
);

export const removeDocumentCategorySuccess = createAction(
  '[DocumentCategory] Remove DocumentCategory Success',
  props<{ ids: string[] }>()
);

export const removeDocumentCategoryFailure = createAction(
  '[DocumentCategory] Remove DocumentCategory Failure',
  props<{ error: any }>()
);
